/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBPROPOSALSTATUS = {
    ProposalInProgress: '1',
    ProposalComplete: '2',
    ApplicationInProgress: '3',
    ApplicationComplete: '4',
    SigningInProgress: '5',
    SigningComplete: '6'
} as const;
export type GHUBPROPOSALSTATUS = typeof GHUBPROPOSALSTATUS[keyof typeof GHUBPROPOSALSTATUS];


export function GHUBPROPOSALSTATUSFromJSON(json: any): GHUBPROPOSALSTATUS {
    return GHUBPROPOSALSTATUSFromJSONTyped(json, false);
}

export function GHUBPROPOSALSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBPROPOSALSTATUS {
    return json as GHUBPROPOSALSTATUS;
}

export function GHUBPROPOSALSTATUSToJSON(value?: GHUBPROPOSALSTATUS | null): any {
    return value as any;
}

